import * as S from "@components/navbar/style/MobileNavbar.styled";
import React from "react";

interface LogoutItemProps {
  onLogout: () => void;
}

export const LogoutItem: React.FC<LogoutItemProps> = ({ onLogout }) => (
  <S.SidebarLink as="div" onClick={onLogout} to="">
    <span>Выйти</span>
  </S.SidebarLink>
);
